import React, { useState, useEffect } from 'react';
import './AnchorScrollingTotemInfo.css'; // Per includere il CSS

const AnchorScrollingTotemInfo = () => {
  const [activeSection, setActiveSection] = useState('#s1');

  // Gestire il click sui link della navbar
  const handleClick = (event, sectionId) => {
    event.preventDefault(); // Prevenire il comportamento di default
    setActiveSection(sectionId); // Impostare la sezione attiva
    const target = document.querySelector(sectionId);
    window.scrollTo({
      top: target.offsetTop - 160, // Offset per tenere conto della navbar
      behavior: 'smooth', // Scrolling fluido
    });
  };

  useEffect(() => {
    // Impostare l'active class sui link quando la pagina viene caricata o lo stato cambia
    const links = document.querySelectorAll('.nav a');
    links.forEach((link) => {
      if (link.getAttribute('href') === activeSection) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }, [activeSection]);

  return (
    <div>
      {/* Navbar come normale componente */}
      <nav className="nav">
        <a href="#s1" style={{marginLeft: "10px", fontSize: "16px"}} className={` aAnchor ${activeSection === '#s1' ? 'active' : ''}`} onClick={(e) => handleClick(e, '#s1')}>
          Intro
        </a>
        <a href="#s2" style={{fontSize: "16px"}} className={`aAnchor ${activeSection === '#s2' ? 'active' : ''}`} onClick={(e) => handleClick(e, '#s2')}>
          Report
        </a>
        <a href="#s3" style={{fontSize: "16px"}} className={`aAnchor ${activeSection === '#s3' ? 'active' : ''}`} onClick={(e) => handleClick(e, '#s3')}>
          Criptazione
        </a>
        <a href="#s4" style={{fontSize: "16px"}} className={`aAnchor ${activeSection === '#s4' ? 'active' : ''}`} onClick={(e) => handleClick(e, '#s4')}>
          Sicurezza
        </a>
      </nav>

      {/* Sezioni del contenuto */}
      <div style={{padding: "10px 20px"}} className=''>
       {/* Blocco delle Percentuali con Consenso Partner */}
       <article id="s1">
        <h2>Blocco delle Percentuali con Consenso Partner</h2>
        <p>
          Spiega il processo di consenso richiesto per la modifica delle percentuali. Gli affiliati devono approvare o rifiutare le modifiche prima che vengano applicate.
        </p>
        <p>
          <b>Dettaglio dell'implementazione:</b> Il flusso di approvazione avviene tramite notifiche inviate agli affiliati, che possono visualizzare un log storico delle modifiche e prendere decisioni in tempo reale.
        </p>
        <p>
          Scopri come funziona il consenso delle modifiche
        </p>
      </article>

      {/* Notifiche su Nuovi Ordini e Report Settimanale */}
      <article id="s2">
        <h2>Notifiche su Nuovi Ordini e Report Settimanale</h2>
        <p>
          Gli affiliati vengono notificati riguardo agli ordini e alle commissioni ricevute. Possono anche ricevere un report settimanale riepilogativo delle attività svolte.
        </p>
        <p>
          Le notifiche sono inviate tramite email, SMS o push notifications, a seconda delle preferenze dell'affiliato.
        </p>
        <p>
          Ricevi notifiche in tempo reale sulle tue commissioni
        </p>
      </article>

      {/* Criptazione dei Dati e Sicurezza delle Transazioni */}
      <article id="s3">
        <h2>Criptazione dei Dati e Sicurezza delle Transazioni</h2>
        <p>
          Per proteggere i dati sensibili e le transazioni, utilizziamo metodi di criptazione avanzata come AES-256.
        </p>
        <p>
          In questo modo, gli affiliati possono sentirsi sicuri nell'utilizzo del sistema, sapendo che le loro informazioni sono protette da misure di sicurezza avanzate.
        </p>
        <p>
          Scopri come proteggiamo i tuoi dati
        </p>
      </article>

      {/* Suggerimenti per Massimizzare la Sicurezza */}
      <article id="s4" className="margin">
        <h2>Suggerimenti per Massimizzare la Sicurezza</h2>
        <ul>
          <li><b>Blockchain per la tracciabilità delle transazioni</b></li>
          <li><b>Autenticazione avanzata per un accesso sicuro</b></li>
          <li><b>Monitoraggio tramite AI per prevenire attività sospette</b></li>
        </ul>
        <p>
          <b>API pubblica con accessi limitati per migliorare la protezione dei dati</b>
        </p>
      </article>
      </div>
      
    </div>
  );
};

export default AnchorScrollingTotemInfo;
